var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{ref:"chartId",style:('max-height:' + _vm.height + 'px'),attrs:{"id":_vm.chartId}})
}
var staticRenderFns = []

export { render, staticRenderFns }